import { PublicPageTemplate } from "./PublicPageTemplate";

const CrowdfundingPage = () => (
  <PublicPageTemplate
    badge="Crowdfunding"
    title="Participez à la"
    highlight="révolution IA"
    description="Rejoignez notre campagne de financement participatif et devenez acteur de la transformation digitale des entreprises."
  />
);
export default CrowdfundingPage;
